// Doc https://material-table.com/#/docs/all-props https://github.com/mbrn/material-table

import React, { Fragment, useState, useEffect } from "react";
import _ from 'lodash';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import MaterialTable, { MTableToolbar } from "material-table";
import { withStyles } from '@material-ui/core/styles';
import * as H from 'helper';

const Top10TxByPmid = ({classes, title, source, loading, dataByPmid}) => {
    const [geoData, setGeoData] = useState([]);

    useEffect(() => {
        //console.log('yoyo');
    }, []);

    useEffect(() => {
        let dataSource = source === "auction" ? dataByPmid.count.auction : dataByPmid.count.store;
        let totalNum = _.sumBy(dataSource, data => {
            return data.value;
        });
        let dataArray = [], dataObj = {};
        for (let i=0; i<dataSource.length; i++) {
            dataObj.no = i+1;
            dataObj.url = dataSource[i]['country'] === '(not set)' || dataSource[i]['country'] === 'n/a' ? false : H.CountryHelper.getCountryCode(dataSource[i]['country']);
            dataObj.country = dataSource[i]['country'];
            dataObj.pmid = dataSource[i]['pmid'];
            dataObj.num_reg = dataSource[i]['value'];
            dataObj.num_ratio = (dataSource[i]['value'] / totalNum * 100).toFixed(2);
            dataArray.push(dataObj);
            dataObj = {};
        }
        setGeoData(dataArray);
    }, [dataByPmid]);

    return(
        <MaterialTable
            isLoading={loading.ovByPmid}
            style={{padding: 16, fontSize: 14}}
            title={<div style={{fontSize: 18, fontWeight: 500, color: '#000'}}>{title}</div>}
            columns={[
                { title: '#', field: 'no', width: 50, cellStyle: {textAlign:'center'}},
                { title: '国・PMID', field: 'country', width: 350,
                    render: rowData => <Fragment>
                                            <div style={{display:'flex'}}>
                                                <div>
                                                    {rowData.url &&
                                                    <img src={rowData.url} style={{paddingTop: 2, paddingRight: 8, width: 24}}/>
                                                    }
                                                </div>
                                                <div style={{paddingTop: 4}}>{rowData.pmid}</div>
                                            </div>
                                        </Fragment>
                },
                { title: '取引件数', field: 'num_reg', width: 200, type: 'numeric', cellStyle: {textAlign:'center'},
                    render: rowData => <div>{H.FormatNumStrHelper.formatCommaThousand(rowData.num_reg)}</div>},
                { title: '全体比率',field: 'num_ratio', type: 'numeric', cellStyle: {textAlign:'left', marginLeft: 32},
                    render: rowData => <Fragment>
                                            <div style={{display:'flex', height: 16}}>
                                                <div style={{paddingRight: 16, width: 24}}>{rowData.num_ratio}%</div>
                                                <div style={{backgroundColor: '#65C9A5', width:rowData.num_ratio+'%', marginLeft: 20, marginTop:3}}></div>
                                            </div>
                                        </Fragment>
                },
            ]}
            data={geoData}
            options={{
                search: false,
                paging: false,
                sorting: false,
                rowStyle: {
                    textAlign:'center',
                },
                headerStyle: {textAlign:'center'}
            }}
            localization={{
                body: {
                    emptyDataSourceMessage: '表示可能なデータがありません',
                },
            }}
        />
    )
};

Top10TxByPmid.propTypes = {
    classes: PropTypes.object,
};

const mapStateToProps = state => ({
    loading: state.nftDepOverview.loading,
    dataByPmid: state.nftDepOverview.dataByPmid,
});

const mapDispatchToProps = dispatch => ({

});

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(null, { withTheme: true })(Top10TxByPmid));
